import {Component, Inject, Vue} from 'vue-property-decorator'
import {INJECT} from '@/utils/constants'
import IconsContainer from '@/utils/IconsContainer'

@Component
export default class IconPathsMixin extends Vue {
    @Inject(INJECT.ICON_CONTAINER) icons!: IconsContainer
}